<section class="search-api">
  @if (chipsList()) {
    <fin-chips-filtering data-testid="chips-filter" [chipsList]="chipsList()"></fin-chips-filtering>
  }

  @if (items$ | async; as items) {
    @if (total$ | async; as total) {
      <p
        class="flex flex--nogrow bold-type count"
        [innerHTML]="
          (total === 1
            ? ('blueWingsSEO.articleSingular' | finLocalization)
            : ('blueWingsSEO.articlePlural' | finLocalization)
          ).replace('{{count}}', total)
        "
      ></p>
    }

    <div class="search-api-list grid-col-12 no-gutters">
      @for (item of items; track item) {
        <fin-teaser-card
          class="col-1-12 card-wrapper grid-third"
          [aspectRatio]="'16x9'"
          [content]="item"
        ></fin-teaser-card>
      }

      @for (item of loadMoreItems$ | async; track item) {
        <fin-teaser-card
          class="col-1-12 card-wrapper grid-third"
          [aspectRatio]="'16x9'"
          [content]="item"
        ></fin-teaser-card>
      }
    </div>

    @if (showLoadMore$ | async) {
      <fcom-button
        data-testid="load-more"
        class="col-1-12 mr-medium-t"
        [href]="nextPageLink$ | async"
        [text]="'actions.loadMore' | finLocalization"
        [loading]="loadMoreLoading"
        (clickBtn)="loadMore($event)"
      ></fcom-button>
    }
  }

  @if (itemsLoader$ | async) {
    <div class="flex flex--column col-1-12">
      <fcom-loader [loaderType]="LoaderTheme.INLINE"></fcom-loader>
    </div>
  }
</section>
